export interface IApiResponse<T> {
  status: 'success' | 'error';
  message: string;
  errors?: ApiError | null;
  data?: T | null;
}

export type ApiError = { [key: string]: boolean | string } | { [key: string]: boolean | string }[];
